module.exports = __webpack_public_path__ + "static/media/special education add icon 1.f4dc5821.svg";